import React, {useState, useEffect, useRef, useContext} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { history } from '../../_helpers';
import { degreeOptions, interestOptions, SMfieldOptions, ITfieldOptions, BMfieldOptions, fieldOptions, SMjobOptions, ITjobOptions, BMjobOptions, abilityOptions, freshOptions } from '../SignIn/data';
import Select from 'react-select';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';



function ComAddRa(){

  let apilink = ''
  let statuspercent = ''

  if(localStorage.getItem("is_headhunter") === "true") {apilink = "/api/rahh/"; statuspercent="HH"}
  else if (localStorage.getItem("is_recruiter") === "true") {apilink = "/api/ra/"; statuspercent="7%"}


  const [state, actions] = useContext(UserContext);
  const [ra, setRa] = useState(null)

  const [title, setTitle] = useState()
  const [field, setField] = useState()
  const [job, setJob] = useState([])
  const [abilities, setAbilities] = useState([])

  const [description, setDescription] = useState()
  const [status, setStatus] = useState(statuspercent)
  // const [active, setActive] = useState()
  const [salaryMin, setSalaryMin] = useState()
  const [salaryMax, setSalaryMax] = useState()
  const [workyears, setWorkyears] = useState()
  const [manager, setManager] = useState()
  const [enddate, setEnddate] = useState()
  const [workadd, setWorkadd] = useState()

  const [domain, setDomain] = useState([])
  const [degree, setDegree] = useState()


  // only for headhunter
  const [company, setCompany] = useState()
  const [companyOptions, setCompanyOptions] = useState()

  const [whichjobOptions, setWhichjobOptions] = useState()

  const [companyPublic, setCompanyPublic] = useState(true)

  // const [companyInfo, setCompanyInfo] = useState()

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };

  let user = JSON.parse(String(localStorage.getItem('user')))
  const header = {Authorization: `JWT ${user.token}`}

  let current_state = history.location.pathname.split('/')[2]
  let current_id = history.location.pathname.split('/')[3]


  function handleDefault(index) {
    let tempObj=[];
    // console.log(index)
    if(index !== undefined){
      if(index.length)
        index.map((item)=>{tempObj.push({value:item, label:item})})
    }
    else{
      console.log("undefined")
    }
    
    // console.log(tempObj)
    return(tempObj)
  }

  function fetchRa(){
    // console.log(field, job, fresh)
    if(current_state === "raadd"){
      fetch(state.awslink + apilink, {
        method: 'POST',
        headers: header,
        body:JSON.stringify({
          "title": title,
          "field": field,
          "job": job,
          "abilities" : abilities,
          "description": JSON.stringify(convertToRaw(editorState.getCurrentContent())),
          "status": status,
          "salary": salaryMin + '~' + salaryMax,
          "workyears": workyears,
          "manager": manager,

          "workadd": workadd,
          "enddate": enddate,

          "domain": domain,
          "degree": degree,

          "company" : company? company[0].id : null,
          "companyPublic": companyPublic
        })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
      })
    } else{
      console.log(ra)
      console.log(company)
      fetch(state.awslink + apilink, {
        method: 'PUT',
        headers: header,
        body:JSON.stringify({
          "id": ra.id,
          "title": title,
          "field": field,
          "job": job,
          "abilities" : abilities,
          "description": JSON.stringify(convertToRaw(editorState.getCurrentContent())),
          "status": status,
          "salary": salaryMin + '~' + salaryMax,
          "workyears": workyears,
          "manager": manager,

          "domain": domain,
          "degree": degree,

          "workadd": workadd,
          "enddate": enddate,

          "company" : company? company.id : null,
          "companyPublic": companyPublic
        })
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
      })
    }
  }

  useEffect(()=>{
    async function fetchCompanyInfoSec(){
      fetch(state.awslink + "/user/companysecond/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        let newobj = []
        if(json.length)
          json.map((item, i)=>{
            newobj.push({value: item.title, label: item.title, id: item.id})

          })
        // console.log(newobj)
        setCompanyOptions(newobj)
      })
    }

    async function fetchRaSingle(){
      fetch(state.awslink + apilink + '?id=' + current_id, {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        
        let parsed = EditorState.createWithContent(convertFromRaw(JSON.parse(json.description))) 

        setTitle(json.title)
        setField(json.field)
        if(json.field){
          if(SMfieldOptions.filter((item)=>item.value === json.field).length){
            let index = SMfieldOptions.findIndex((item)=>item.value===json.field)
            setWhichjobOptions(SMjobOptions[index])
          }
          else if(ITfieldOptions.filter((item)=>item.value === json.field).length){
            let index = ITfieldOptions.findIndex((item)=>item.value===json.field)
            setWhichjobOptions(ITjobOptions[index])
          }
          else if(BMfieldOptions.filter((item)=>item.value === json.field).length){
            let index = BMfieldOptions.findIndex((item)=>item.value===json.field)
            setWhichjobOptions(BMjobOptions[index])
          } 
        }

        if(json.company)
          setCompany({value:json.company.title, label: json.company.title, id: json.company.id})
        setDomain(json.domain)
        setDegree(json.degree)
        setJob(json.job)
        setEditorState(parsed)
        setAbilities(json.abilities)
        setStatus(json.status)
        if(json.salary){
          setSalaryMin(json.salary.split("~")[0])
          setSalaryMax(json.salary.split("~")[1])
        }
        else{
          setSalaryMax()
          setSalaryMin()
        }
        setWorkyears(json.workyears)
        setManager(json.manager)
        setEnddate(json.enddate)
        setWorkadd(json.workadd)

        setRa(json)

      })
    }


    if(localStorage.getItem("is_headhunter") === "true") fetchCompanyInfoSec()

    if(current_state === "raedit") fetchRaSingle()
    // fetchCompanyInfo()
    
  }, [])
  // console.log(ra)
  
  // if(ralist === null){
  //   if(state.token != undefined)
  //     fetchRalist();
  // }
  // const handleChange = (nameTag) => e => {
  //   // if(nameTag === "ab") setAbilities(Array.isArray(e) ? e.map(x => x.value) : []);
  //   // else if(nameTag === "int") setInterests(Array.isArray(e) ? e.map(x => x.value) : []);
  //   if(nameTag === "job") setJob(Array.isArray(e) ? e.map(x => x.value) : []);
  //   else if(nameTag === "abilities") setAbilities(Array.isArray(e) ? e.map(x => x.value) : []);
  // }

  const handleChange = (func) => e => {
    func(Array.isArray(e) ? e.map(x => x.value) : [])

  }
  const handleJob = job => {
    handleDefault(job)
  }
  const removeJob = (option) => {
    let newSelect = job
    
    if(job && job.length){
      job.map((item, index)=>{
        if(!option.includes({value: item, label: item})){
          newSelect = []
        }
      })
      setJob(newSelect)
    }
  };
  
  
  function CommonUI() {
    return(
      <ProfileForm>

        <ContentForm>
          {localStorage.getItem("is_headhunter") === "true" &&
              // ra ? 
              companyOptions && company ?
              <>
                <h4>
                  회사
                </h4>
                <Select
                  className="basic-single"
                  defaultValue={
                    companyOptions.filter((item)=>item.value===company.value)
                  }
                  isSearchable={true}
                  name="color"
                  options={companyOptions? companyOptions : {value: "없음", label: "없음"} }
                  onChange={(e)=>{setCompany(companyOptions.filter((item, i)=> item.value === e.value)[0])}}
                />
                <input type='checkbox' checked={companyPublic} onChange={()=>setCompanyPublic(!companyPublic)}></input>
              </> 
              :
              localStorage.getItem("is_headhunter") === "true" &&
              <>
                <h4>
                  회사
                </h4>
                <Select
                  className="basic-single"
                  defaultValue={null}
                  isSearchable={true}
                  name="color"
                  options={companyOptions? companyOptions : {value: "없음", label: "없음"} }
                  onChange={(e)=>{setCompany(companyOptions.filter((item, i)=> item.value === e.value)[0])}}
                />
                <input type='checkbox' checked={companyPublic} onChange={()=>setCompanyPublic(!companyPublic)}></input>
              </> 
          }

          <div>
            <h4>
              직군
            </h4>
            <div>
              <Select
                className="basic-single"
                defaultValue={fieldOptions.filter((item)=>item.value===field)}
                // defaultValue={{ value: field, label: field}}
                isSearchable={true}
                name="color"
                options={fieldOptions}
                onChange={(e)=>{
                  if(e.value) {
                    setField(e.value)
                    if(SMfieldOptions.filter((item)=>item.value === e.value).length){
                      let index = SMfieldOptions.findIndex((item)=>item.value===e.value)
                      setWhichjobOptions(SMjobOptions[index])
                      removeJob(SMjobOptions[index])
                    }
                    else if(ITfieldOptions.filter((item)=>item.value === e.value).length){
                      let index = ITfieldOptions.findIndex((item)=>item.value===e.value)
                      setWhichjobOptions(ITjobOptions[index])
                      removeJob(ITjobOptions[index])
                    }
                    else if(BMfieldOptions.filter((item)=>item.value === e.value).length){
                      let index = BMfieldOptions.findIndex((item)=>item.value===e.value)
                      setWhichjobOptions(BMjobOptions[index])
                      removeJob(BMjobOptions[index])
                    } 
                  }
                  // handleInit()
                }}
              />
            </div>
          </div>

          <div>
            <h4>
              직무
            </h4>
            <div>
              <Select
                defaultValue={handleDefault(job)}
                className="basic-multi"
                isMulti
                isSearchable={true}
                options={whichjobOptions}
                value={handleDefault(job)}
                onChange={handleChange(setJob)}
              />
            </div>
          </div>

          <div>
            <h4>
              요소기술
            </h4>
            <div>
              <Select
                defaultValue={handleDefault(abilities)}
                className="basic-multi"
                isMulti
                isSearchable={true}
                options={abilityOptions}
                onChange={handleChange(setAbilities)}
              />
            </div>
          </div>

          <div>
            <h4>
              도메인
            </h4>
            <div>
             <Select
                defaultValue={handleDefault(domain)}
                className="basic-multi"
                isMulti
                isSearchable={true}
                options={interestOptions}
                onChange={handleChange(setDomain)}
              />
            </div>
          </div>

          <div>
            <h4>
              경력
            </h4>
            <div>
              <Select
                className="basic-single"
                defaultValue={freshOptions.filter(item=>item.value===workyears)}
                // defaultValue={handleDefault(workyears)}
                isSearchable={true}
                name="color"
                options={freshOptions}
                onChange={(e)=>{if(e.value) setWorkyears(e.value)}}
              />
            </div>
          </div>

          <div>
            <h4>
              학위
            </h4>
            <div>
              <Select
                className="basic-single"
                defaultValue={degreeOptions.filter(item=>item.value===degree)}
                isSearchable={true}
                name="color"
                options={degreeOptions}
                onChange={(e)=>{setDegree(e.value)}}
              />
            </div>
          </div>


          <div>
            <h4>
              예상연봉
            </h4>
            <div>
            <input className="basic-input" value={salaryMin} onChange={(e)=>setSalaryMin(e.target.value)}/>
            ~<input className="basic-input" value={salaryMax} onChange={(e)=>setSalaryMax(e.target.value)}/>

            </div>
          </div>

          <div>
            <h4>
              마감일
            </h4>
            <div>
              <input className="basic-input" value={enddate} onChange={(e)=>setEnddate(e.target.value)}/>
            </div>
          </div>
          
          <div>
            <h4>
              상태
            </h4>
            <div>
            <input className="basic-input" value={status} onChange={(e)=>setStatus(e.target.value)}/>
            </div>
          </div>

          <div>
            <h4>
              관리자연락처
            </h4>
            <div>
              <input className="basic-input" value={manager} onChange={(e)=>setManager(e.target.value)}/>
            </div>
          </div>

          <div>
            <h4>
              근무지주소
            </h4>
            <div>
              <input className="basic-input" value={workadd} onChange={(e)=>setWorkadd(e.target.value)}/>
            </div>
          </div>

          <div className="devider"></div>
          
          <div>
            <h4>
              제목
            </h4>
            <div>
              <input className="basic-input" value={title} onChange={(e)=>setTitle(e.target.value)}/>
            </div>
          </div>
          
          <div>
            <h4>
              내용
            </h4>
            <div>
              <MyBlock>
              <Editor
                wrapperClassName="wrapper-class"
                editorClassName="editor"
                toolbarClassName="toolbar-class"
                toolbar={{
                  list: { inDropdown: false },
                  textAlign: { inDropdown: false },
                  link: { inDropdown: true },
                  history: { inDropdown: false },
                }} 
                placeholder="내용을 작성해주세요."
                localization={{locale: 'ko',}}
                editorState={editorState}
                onEditorStateChange={onEditorStateChange}
              />
              </MyBlock>
            </div>
          </div>
          
          <div className={"addra-btn"}>
            <button onClick={()=>{fetchRa(); history.push('/recruiter/ra');}}>
              저장
            </button>
          </div>

        </ContentForm>
        
      </ProfileForm>
    )
  }

  console.log(companyPublic, company)
  // console.log(fieldOptions.filter((item)=>item.value===field))
  return(
    <>
    {/* {state.width < state.breakpoint ? 
      null
    : */}
      <Wrapper>
        <RaWrapper>
          {current_state === "raedit" ? 
            field && job && abilities && workyears &&
            CommonUI()
          : 
            CommonUI()
          }
          
          {/* <button onClick={()=>{fetchRa(); history.push('/recruiter/ra');}}>
            저장
          </button> */}
        </RaWrapper>
      </Wrapper>   
      {/* } */}
    </>
  )
}

const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: flex;
  margin: 0 auto;
  background-color: whitesmoke;
  flex-direction: column;
`


const ProfileForm = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  padding-left: 0px;
  display: flex;
  margin: 0;
  /* flex-wrap: nowrap; */
  text-align: left;
  vertical-align: top;

  /* min-height: 300px; */

`

const ContentForm = styled.div`
    width: 100%;
    position: relative;
    display: block;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    box-sizing: border-box;
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;

    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    border: .5px solid rgba(0,0,0,0.2);

    .devider{
      display: block;
      height: 1px;
      margin-top: 40px;
      border-top: 1px solid rgba(0,0,0,0.2);
    }

    .addra-btn{
      display: flex;
      justify-content: flex-end;
      button{
        cursor: pointer;
        margin: 0;
        margin-bottom: 10px;
        width: 150px;
        height: 45px;
        border-radius: 10px;
        background-color: rgba(253,134,18,0.8);
        border: none;
        color: white;
        font-weight: bold;
        font-size: 1.1rem;  

        transition: .2s;
        :hover{
          background-color: rgba(253,134,18, 0.9);
        }
        :active{
          background-color: rgba(253,134,18, 1);
        }
      }
    }
    .basic-single{
      width: 50%;
    }
    >div{
      margin-bottom: 20px;
      h4{
        margin: 0;
        padding-top: 20px;
        padding-bottom: 10px;
      }
      >div{
        /* padding-left: 40px; */
        font-size: 0.9rem;
        .basic-single{
          width: 200px;
        }

        .basic-multi{
          width: 200px;
        }

      }
      .ras-tag{
        >div{
          display: inline-block;
          font-size: 0.8rem;
          border: .5px solid rgba(0,0,0,0.2);
          border-radius: 12px;
          padding: 7px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
          margin-left: 0;
          margin-right: 10px;
        }
      }
      .ras-work{
        margin-bottom: 10px;
        h4{
          font-size: 1rem;
          padding-top: 10px;
          padding-bottom: 5px;
        }
        .ras-work-memo{
          font-size: 1rem;
          margin-top: 10px;
          margin-bottom: 10px;
        }
        /* span{
          display: inline-flex;
          justify-content: center;
          align-items: center;
        } */
        ul{
          padding-left: 20px;
        }
      }
      
    }
`
const MyBlock = styled.div`
  /* margin-top: 100px; */
  .wrapper-class{
      width: 100%;
      margin: 0 auto;
      margin-bottom: 4rem;
  }
  .editor {
    height: 500px !important;
    border: 1px solid rgba(0,0,0,0.2) !important;
    padding: 5px !important;
    border-radius: 2px !important;
    background-color: white;
  }

  .rdw-editor-toolbar{
    border: 1px solid rgba(0,0,0,0.2) !important;
  }
  .rdw-dropdown-wrapper{
    /* z-index: 1; */
  }

  .rdw-text-align-dropdown{
    z-index: 0;
  }
  .rdw-list-dropdown{
    z-index: 0;
  }
  .DraftEditor-editorContainer{
    z-index: 0;
  }
`;

export default ComAddRa